import { memo } from "react";
import { Box } from "@mui/material";

import { useAppContext } from "../../../2_ksbHub/context/appContext";

import AppContentWrapper from "../../../2_ksbHub/components/AppContentWrapper";

import BSZPlannerMain from "./BSZPlannerMain";
import BSZPlannerDialogs from "./dialogComponents/BSZPlannerDialogs";
import BSZPlannerAlerts from "./alerts/BSZPlannerAlerts";

import useBszPlannerActions from "../hooks/useBszPlannerActions";
import useBszPlannerDialogs from "../hooks/useBszPlannerDialogs";
import { useBszPlannerContext } from "../context/bszPlannerContext";

/**
 * =========================================================
 * ✅ BSZ CONTENT (stable + aligned)
 * =========================================================
 */
function BSZPlannerContent({ viewMode }) {
  const { isMobile } = useAppContext();

  const { projects: rawProjects } = useBszPlannerContext();

  /**
   * ✅ CRITICAL FIX: NEVER allow undefined
   */
  const projects = Array.isArray(rawProjects) ? rawProjects : [];

  const actions = useBszPlannerActions();
  const dialogs = useBszPlannerDialogs();

  /**
   * =========================================================
   * ✅ RENDER
   * =========================================================
   */
  return (
    <Box
      sx={{
        flex: 1,
        mt: isMobile ? 1 : 0,
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* ✅ CONTENT */}
      <AppContentWrapper padding={false} gap={1.2} scrollable={false}>
        <BSZPlannerMain
          viewMode={viewMode}
          projects={projects}
          dialogs={dialogs}
          actions={actions}
        />
      </AppContentWrapper>

      {/* ✅ DIALOGS */}
      <BSZPlannerDialogs dialogs={dialogs} actions={actions} />

      {/* ✅ ALERTS */}
      <BSZPlannerAlerts actions={actions} />
    </Box>
  );
}

export default memo(BSZPlannerContent);
